import PencilIcon from '@components/icons/Pencil.svg';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useModalContext } from '@providers/ModalProvider';
import { EntityIconProfile } from '@components/core-ui/EntityIcon/variations/EntityIconProfile';
import { AvatarBlock } from './styles/AvatarBlock';
import { InputBlockWrapper } from './styles/InputBlockWrapper';
import { InputWrapper } from './styles/InputWrapper';
import { LeftSide } from './styles/LeftSide';
import { RightSide } from './styles/RightSide';
import { RightSideColumns } from './styles/RightSideColumns';
import { Wrapper } from './styles/Wrapper';
import { AdminUserDetailsResultDto } from 'app/API';

type TProps = {
  user: AdminUserDetailsResultDto;
  reload: () => void;
};

export const UserDetails = ({ user, reload }: TProps) => {
  const { openModal, closeModal } = useModalContext();
  if (!user) {
    return null;
  }

  const editPhone = () => {
    openModal(ModalNamesEnum.EditUserPhone, {
      onSuccess: () => {
        closeModal();
        reload();
      },
      id: user.id,
      phone: user.phone,
    });
  };

  const editEmail = () => {
    openModal(ModalNamesEnum.EditUserEmail, {
      onSuccess: () => {
        closeModal();
        reload();
      },
      id: user.id,
      email: user.email,
    });
  };

  const renderAvatar = () => {
    if (!user || !user.name || !user.lastname) {
      return '';
    }

    return (
      <AvatarBlock>
        <EntityIconProfile name={`${user.name} ${user.lastname}`} src={user.avatar ?? undefined} />
      </AvatarBlock>
    );
  };

  return (
    <Wrapper>
      <LeftSide>
        <h3>General</h3>
      </LeftSide>

      <RightSide>
        {renderAvatar()}
        <RightSideColumns>
          <InputBlockWrapper>
            <InputWrapper>
              <div className="label">Name</div>
              <div className="value">
                {user.name} {user.lastname}
              </div>
            </InputWrapper>
            <InputWrapper>
              <div className="label">Email</div>
              <div className="value">
                {user.email}
                <PencilIcon
                  className="pencil text-[var(--color-text-muted)] hover:text-[var(--color-accent)] cursor-pointer"
                  onClick={() => editEmail()}
                />
              </div>
            </InputWrapper>
          </InputBlockWrapper>
          <InputBlockWrapper>
            <InputWrapper>
              <div className="label">Phone</div>
              <div className="value">
                {user.phone}
                <PencilIcon
                  className="pencil text-[var(--color-text-muted)] hover:text-[var(--color-accent)] cursor-pointer"
                  onClick={() => editPhone()}
                />
              </div>
            </InputWrapper>
          </InputBlockWrapper>
        </RightSideColumns>
      </RightSide>
    </Wrapper>
  );
};
